import React from "react";
import ClubMainPage from "../Club/ClubMainPage";
import "./RFQ.css";
import SecondaryNavbar from "../SecondaryNavbar/SecondaryNavbar";

const userTypes = ["FOOD-PROCESSOR", "AssetDeveloper"];

export default function RFQ() {
  const navData = [
    { to: "/RFQ", link: "RFQ" },
    { to: "/Tender", link: "Tender" },
    { to: "/ContractFarming", link: "Contract Farming" },
    { to: "/ContractManufacturing", link: "Contract Manufacturing" },
    { to: "/TimelyDelivery", link: "Timely Delivery" },
  ];

  return (
    <>
      <SecondaryNavbar props={navData} />
      <div className="subSectionWrapper">
        <ClubMainPage type={userTypes} />
      </div>
    </>
  );
}
